import axios from 'axios';

export default {
  
  getVersion: async () => {
    let url = `${process.env.REACT_APP_API_URL}`;
    return await axios.get(url);
  },

}